import { MessageBarType } from '@fluentui/react';
import { Button, buttonStylesStealth, FluentClickHandler } from '@h2oai/ui-kit';

import type { Banner } from '../../../utils/models';

export const getMessageBarType = (severity: string): MessageBarType => {
  switch (severity) {
    case 'error':
      return MessageBarType.error;
    case 'warning':
      return MessageBarType.warning;
    case 'blocked':
      return MessageBarType.blocked;
    case 'success':
      return MessageBarType.success;
    case 'severe':
      return MessageBarType.severeWarning;
    default:
      return MessageBarType.info;
  }
};

export const BOOK_TIME_BANNER_ID = 'book-time-banner';

export const createBookTimeBanner = (onClickBookTime: FluentClickHandler): Banner => ({
  id: BOOK_TIME_BANNER_ID,
  messageBarType: MessageBarType.warning,
  actions: (
    <div>
      <Button styles={buttonStylesStealth} text="Book a Time" onClick={onClickBookTime} />
    </div>
  ),
  message: `On trial or provisional accounts, H2O advises against uploading and/or using data with personally identifiable
            information (PII) or other sensitive data. Please schedule a call with one of our Activation Specialists to
            learn how to safely use your own data in the H2O AI Cloud.`,
});
